import gql from 'graphql-tag';
import { QueryResult } from '../shared/object/queryResult.model';
import { BehaviorSubject } from 'rxjs';
import { take, tap, pluck, withLatestFrom } from 'rxjs/operators';
import * as i0 from "@angular/core";
import * as i1 from "../shared/services/graph-qlclient.service";
import * as i2 from "apollo-angular/Apollo";
// * QUERY FILTRO CLIENTES
const QUERY_PRODUCTOS_REGISTROS = gql `
  query ($empresa_rut: Decimal, $sku: String, $descripcion: String, $tipobusqueda_estado: Int, $familia: [Decimal], $paginaActual: Int, $cantidadRegistrosPorPagina: Int) {
    producto {
      obtenerSegunFiltroProductosModulo(
        filtro: { exacto: { empresa_rut: $empresa_rut, sku: $sku, descripcion: $descripcion, tipobusqueda_estado: $tipobusqueda_estado } }
        familia: $familia
        paginaActual: $paginaActual
        cantidadRegistrosPorPagina: $cantidadRegistrosPorPagina
      ) {
        mensajes {
          codigo
          texto
          tipo
        }
        respuesta {
          paginaActual
          cantidadRegistrosPorPagina
          totalPaginas
          totalRegistros
          registros {
            codigo
            empresa_rut
            sku
            seguimiento
            descripcion
            descripcion_ext
            es_exento
            codigo_barras
            fecha_registro
            activo
            favorito
            familia_codigo
            tipo_producto_codigo
            unidad_medida_codigo
            afecto_reglas_comerciales
            no_aplica_descuento
            fecha_caducidad_combo
            fecha_inicio_combo
            rubro_codigo
            unidad_negocio_codigo
          }
        }
      }
    }
  }
`;
export class ProductoService {
    constructor(gqlclient, apollo) {
        this.gqlclient = gqlclient;
        this.apollo = apollo;
        this.clientesDataSubject = new BehaviorSubject(null);
        this.Productss$ = this.clientesDataSubject.asObservable();
    }
    //* DEVUELVE OBSERVABLE CON LA RESPUESTA DE LA QUERY
    GetProductFiltro(inputParams) {
        this.postsQuery = this.apollo.watchQuery({
            query: QUERY_PRODUCTOS_REGISTROS,
            variables: inputParams,
            fetchPolicy: 'network-only',
        });
        this.queryProductos = this.postsQuery.valueChanges.pipe(take(1), pluck('data', 'producto'), withLatestFrom(this.Productss$), tap(([apiResponse, respuesta]) => {
            return apiResponse.obtenerSegunFiltroProductosModulo.respuesta;
        }));
    }
    obtenerSegunFiltroProductos(inputParams, callback) {
        this.gqlclient.query({
            query: gql `
          query (
            $empresa_rut: Decimal
            $sucursal_codigo: Decimal
            $sku: String
            $descripcion: String
            $tipobusqueda_estado: Int
            $tipobusquedad_afecto_exento: Int
            $familia: [Decimal]
            $rubro: [Decimal]
            $paginaActual: Int
            $cantidadRegistrosPorPagina: Int
          ) {
            producto {
              obtenerSegunFiltroProductos(
                filtro: {
                  exacto: {
                    empresa_rut: $empresa_rut
                    sucursal_codigo: $sucursal_codigo
                    sku: $sku
                    descripcion: $descripcion
                    tipobusqueda_estado: $tipobusqueda_estado
                    tipobusquedad_afecto_exento: $tipobusquedad_afecto_exento
                  }
                }
                familia: $familia
                rubro: $rubro
                paginaActual: $paginaActual
                cantidadRegistrosPorPagina: $cantidadRegistrosPorPagina
              ) {
                respuesta {
                  paginaActual
                  cantidadRegistrosPorPagina
                  totalPaginas
                  totalRegistros
                  registros {
                    codigo
                    empresa_rut
                    sku
                    descripcion
                    descripcion_ext
                    es_exento
                    seguimiento
                    codigo_barras
                    fecha_registro
                    activo
                    favorito
                    familia_codigo
                    tipo_producto_codigo
                    unidad_medida_codigo
                    afecto_reglas_comerciales
                    no_aplica_descuento
                    fecha_caducidad_combo
                    fecha_inicio_combo
                    rubro_codigo
                    unidad_negocio_codigo
                    precio_unitario
                    formato_codigo
                    formato_nombre
                    cantidad
                  }
                }
              }
            }
          }
        `,
            variables: inputParams,
            fetchPolicy: 'no-cache',
        }, function (response) {
            const { mensajes, respuesta } = response.data.producto.obtenerSegunFiltroProductos;
            if (!respuesta) {
                callback(new QueryResult(null, 0, 0, 0));
                return;
            }
            const { registros, paginaActual, totalPaginas, totalRegistros } = respuesta;
            // callback({ registros, paginaActual, totalPaginas, totalRegistros })
            callback(new QueryResult(registros, paginaActual, totalPaginas, totalRegistros));
        });
    }
    obtenerSegunFiltroProductosVC(inputParams, callback) {
        this.gqlclient.query({
            query: gql `
          query (
            $empresa_rut: Decimal
            $sucursal_codigo: Decimal
            $sku: String
            $descripcion: String
            $tipobusqueda_estado: Int
            $tipobusquedad_afecto_exento: Int
            $familia: [Decimal]
            $rubro: [Decimal]
            $paginaActual: Int
            $cantidadRegistrosPorPagina: Int
          ) {
            producto {
              obtenerSegunFiltroProductosVC(
                filtro: {
                  exacto: {
                    empresa_rut: $empresa_rut
                    sucursal_codigo: $sucursal_codigo
                    sku: $sku
                    descripcion: $descripcion
                    tipobusqueda_estado: $tipobusqueda_estado
                    tipobusquedad_afecto_exento: $tipobusquedad_afecto_exento
                  }
                }
                familia: $familia
                rubro: $rubro
                paginaActual: $paginaActual
                cantidadRegistrosPorPagina: $cantidadRegistrosPorPagina
              ) {
                respuesta {
                  paginaActual
                  cantidadRegistrosPorPagina
                  totalPaginas
                  totalRegistros
                  registros {
                    codigo
                    empresa_rut
                    sku
                    descripcion
                    descripcion_ext
                    es_exento
                    seguimiento
                    codigo_barras
                    fecha_registro
                    activo
                    favorito
                    familia_codigo
                    tipo_producto_codigo
                    unidad_medida_codigo
                    afecto_reglas_comerciales
                    no_aplica_descuento
                    fecha_caducidad_combo
                    fecha_inicio_combo
                    rubro_codigo
                    unidad_negocio_codigo
                    precio_unitario
                    formato_codigo
                    formato_nombre
                    cantidad
                  }
                }
              }
            }
          }
        `,
            variables: inputParams,
            fetchPolicy: 'no-cache',
        }, function (response) {
            const { mensajes, respuesta } = response.data.producto.obtenerSegunFiltroProductosVC;
            if (!respuesta) {
                callback(new QueryResult(null, 0, 0, 0));
                return;
            }
            const { registros, paginaActual, totalPaginas, totalRegistros } = respuesta;
            // callback({ registros, paginaActual, totalPaginas, totalRegistros })
            callback(new QueryResult(registros, paginaActual, totalPaginas, totalRegistros));
        });
    }
    obtenerSegunFiltroProductosModulo(inputParams, callback) {
        this.gqlclient.query({
            query: gql `
          query (
            $empresa_rut: Decimal
            $sucursal_codigo: Decimal
            $sku: String
            $descripcion: String
            $tipobusqueda_estado: Int
            $tipobusquedad_afecto_exento: Int
            $familia: [Decimal]
            $rubro: [Decimal]
            $paginaActual: Int
            $cantidadRegistrosPorPagina: Int
          ) {
            producto {
              obtenerSegunFiltroProductosModulo(
                filtro: {
                  exacto: {
                    empresa_rut: $empresa_rut
                    sucursal_codigo: $sucursal_codigo
                    sku: $sku
                    descripcion: $descripcion
                    tipobusqueda_estado: $tipobusqueda_estado
                    tipobusquedad_afecto_exento: $tipobusquedad_afecto_exento
                  }
                }
                familia: $familia
                rubro: $rubro
                paginaActual: $paginaActual
                cantidadRegistrosPorPagina: $cantidadRegistrosPorPagina
              ) {
                respuesta {
                  paginaActual
                  cantidadRegistrosPorPagina
                  totalPaginas
                  totalRegistros
                  registros {
                    codigo
                    empresa_rut
                    sku
                    descripcion
                    descripcion_ext
                    es_exento
                    codigo_barras
                    fecha_registro
                    activo
                    favorito
                    familia_codigo
                    tipo_producto_codigo
                    unidad_medida_codigo
                    afecto_reglas_comerciales
                    no_aplica_descuento
                    fecha_caducidad_combo
                    fecha_inicio_combo
                    rubro_codigo
                    unidad_negocio_codigo
                    formato_codigo
                    formato_nombre
                    cantidad
                  }
                }
              }
            }
          }
        `,
            variables: inputParams,
            fetchPolicy: 'no-cache',
        }, function (response) {
            const { mensajes, respuesta } = response.data.producto.obtenerSegunFiltroProductosModulo;
            if (!respuesta) {
                callback(new QueryResult(null, 0, 0, 0));
                return;
            }
            const { registros, paginaActual, totalPaginas, totalRegistros } = respuesta;
            // callback({ registros, paginaActual, totalPaginas, totalRegistros })
            callback(new QueryResult(registros, paginaActual, totalPaginas, totalRegistros));
        });
    }
    ObtenerSegunSku(inputParams, callback) {
        this.gqlclient.query({
            query: gql `
          query (
            $empresa_rut: Decimal
            $sucursal_codigo: Decimal
            $sku: String
            $descripcion: String
            $tipobusqueda_estado: Int
            $tipobusquedad_afecto_exento: Int
            $familia: [Decimal]
            $rubro: [Decimal]
            $paginaActual: Int
            $cantidadRegistrosPorPagina: Int
          ) {
            producto {
              obtenerSegunFiltroProductos(
                filtro: {
                  exacto: {
                    empresa_rut: $empresa_rut
                    sucursal_codigo: $sucursal_codigo
                    sku: $sku
                    descripcion: $descripcion
                    tipobusqueda_estado: $tipobusqueda_estado
                    tipobusquedad_afecto_exento: $tipobusquedad_afecto_exento
                  }
                }
                familia: $familia
                rubro: $rubro
                paginaActual: $paginaActual
                cantidadRegistrosPorPagina: $cantidadRegistrosPorPagina
              ) {
                respuesta {
                  paginaActual
                  cantidadRegistrosPorPagina
                  totalPaginas
                  totalRegistros
                  registros {
                    codigo
                    empresa_rut
                    sku
                    descripcion
                    descripcion_ext
                    es_exento
                    codigo_barras
                    fecha_registro
                    activo
                    favorito
                    familia_codigo
                    tipo_producto_codigo
                    unidad_medida_codigo
                    afecto_reglas_comerciales
                    no_aplica_descuento
                    fecha_caducidad_combo
                    fecha_inicio_combo
                    rubro_codigo
                    unidad_negocio_codigo
                    precio_unitario
                    formato_codigo
                    formato_nombre
                    cantidad
                  }
                }
              }
            }
          }
        `,
            variables: inputParams,
            fetchPolicy: 'no-cache',
        }, function (response) {
            const { mensajes, respuesta } = response.data.producto.obtenerSegunFiltroProductos;
            callback({ mensajes, respuesta });
        });
    }
    obtenerSegunFiltroProductos2(inputParams, callback) {
        this.gqlclient.query({
            query: gql `
          query (
            $empresa_rut: Decimal
            $sku: String
            $descripcion: String
            $tipobusqueda_estado: Int
            $tipobusquedad_afecto_exento: Int
            $familia: [Decimal]
            $rubro: [Decimal]
            $paginaActual: Int
            $cantidadRegistrosPorPagina: Int
          ) {
            producto {
              obtenerSegunFiltroProductos(
                filtro: {
                  exacto: { empresa_rut: $empresa_rut, sku: $sku, descripcion: $descripcion, tipobusqueda_estado: $tipobusqueda_estado, tipobusquedad_afecto_exento: $tipobusquedad_afecto_exento }
                }
                familia: $familia
                rubro: $rubro
                paginaActual: $paginaActual
                cantidadRegistrosPorPagina: $cantidadRegistrosPorPagina
              ) {
                respuesta {
                  paginaActual
                  cantidadRegistrosPorPagina
                  totalPaginas
                  totalRegistros
                  registros {
                    codigo
                    empresa_rut
                    sku
                    descripcion
                    descripcion_ext
                    es_exento
                    codigo_barras
                    fecha_registro
                    activo
                    favorito
                    familia_codigo
                    tipo_producto_codigo
                    unidad_medida_codigo
                    afecto_reglas_comerciales
                    no_aplica_descuento
                    fecha_caducidad_combo
                    fecha_inicio_combo
                    rubro_codigo
                    unidad_negocio_codigo
                    precio_unitario
                    formato_codigo
                    formato_nombre
                    cantidad
                  }
                }
              }
            }
          }
        `,
            variables: inputParams,
            fetchPolicy: 'no-cache',
        }, function (response) {
            const { mensajes, respuesta } = response.data.producto.obtenerSegunFiltroProductos;
            callback({ mensajes, respuesta });
        });
    }
    busquedaMantenedorProductos(inputParams, callback) {
        this.gqlclient.query({
            query: gql `
          query ($empresa_rut: Decimal, $sku: String, $descripcion: String, $tipobusqueda_estado: Int, $familia: [Decimal], $paginaActual: Int, $cantidadRegistrosPorPagina: Int) {
            producto {
              obtenerSegunFiltroProductos(
                filtro: { exacto: { empresa_rut: $empresa_rut, sku: $sku, descripcion: $descripcion, tipobusqueda_estado: $tipobusqueda_estado } }
                familia: $familia
                paginaActual: $paginaActual
                cantidadRegistrosPorPagina: $cantidadRegistrosPorPagina
              ) {
                mensajes {
                  codigo
                  texto
                  tipo
                }
                respuesta {
                  paginaActual
                  cantidadRegistrosPorPagina
                  totalPaginas
                  totalRegistros
                  registros {
                    codigo
                    empresa_rut
                    sku
                    descripcion
                    descripcion_ext
                    es_exento
                    codigo_barras
                    fecha_registro
                    activo
                    favorito
                    familia_codigo
                    tipo_producto_codigo
                    unidad_medida_codigo
                    afecto_reglas_comerciales
                    no_aplica_descuento
                    fecha_caducidad_combo
                    fecha_inicio_combo
                    rubro_codigo
                    unidad_negocio_codigo
                    formato_codigo
                    formato_nombre
                    cantidad
                  }
                }
              }
            }
          }
        `,
            variables: inputParams,
            fetchPolicy: 'no-cache',
        }, function (response) {
            const { mensajes, respuesta } = response.data.producto.obtenerSegunFiltroProductos;
            if (!respuesta) {
                callback(new QueryResult(null, 0, 0, 0), mensajes);
                return;
            }
            const { registros, paginaActual, totalPaginas, totalRegistros } = respuesta;
            // callback({ registros, paginaActual, totalPaginas, totalRegistros })
            callback(new QueryResult(registros, paginaActual, totalPaginas, totalRegistros), mensajes);
        });
    }
    busquedaXSku(inputParams, callback) {
        inputParams.descripcion = '';
        inputParams.familia = [];
        this.gqlclient.query({
            query: gql `
          query ($empresa_rut: Decimal, $sku: String, $codigo_barras: String) {
            producto {
              obtenerSegunId(entidad: { empresa_rut: $empresa_rut, sku: $sku, codigo_barras: $codigo_barras }) {
                mensajes {
                  codigo
                  texto
                  tipo
                }
                respuesta {
                  sku
                  codigo_barras
                  descripcion
                }
              }
            }
          }
        `,
            variables: inputParams,
            fetchPolicy: 'no-cache',
        }, function (response) {
            // const { mensajes, respuesta } = response.data.producto.obtenerSegunId
            if (!response.data.producto.obtenerSegunId.respuesta) {
                callback({
                    respuesta: null,
                    mensajes: response.data.producto.obtenerSegunId.mensajes,
                });
                return;
            }
            callback({
                respuesta: response.data.producto.obtenerSegunId.respuesta,
                mensajes: response.data.producto.obtenerSegunId.mensajes,
            });
        });
    }
    busquedaXCodigoDeBarra(inputParams, callback) {
        inputParams.descripcion = '';
        inputParams.familia = [];
        this.gqlclient.query({
            query: gql `
          query ($empresa_rut: Decimal, $sku: String, $codigo_barras: String) {
            producto {
              obtenerSegunCodigoBarra(entidad: { empresa_rut: $empresa_rut, sku: $sku, codigo_barras: $codigo_barras }) {
                mensajes {
                  codigo
                  texto
                  tipo
                }
                respuesta {
                  sku
                  codigo_barras
                  descripcion
                }
              }
            }
          }
        `,
            variables: inputParams,
            fetchPolicy: 'no-cache',
        }, function (response) {
            // const { mensajes, respuesta } = response.data.producto.obtenerSegunCodigoBarra
            callback({
                respuesta: response.data.producto.obtenerSegunCodigoBarra.respuesta ? response.data.producto.obtenerSegunCodigoBarra.respuesta : null,
                mensajes: response.data.producto.obtenerSegunCodigoBarra.mensajes,
            });
        });
    }
    ValidarProductoParaFacturaMasiva(inputParams, callback) {
        this.gqlclient.query({
            query: gql `
          query ($empresa_rut: Decimal, $codigo: Decimal, $codigo_barras: String) {
            producto {
              validarProducto(entidad: { empresa_rut: $empresa_rut, codigo: $codigo, codigo_barras: $codigo_barras }) {
                mensajes {
                  codigo
                  texto
                  tipo
                }
                respuesta {
                  enAnalisisDemanda
                  enConfirmacionNotaVenta
                  enRecepcionPed
                }
              }
            }
          }
        `,
            variables: inputParams,
            fetchPolicy: 'no-cache',
        }, function (response) {
            // const { mensajes, respuesta } = response.data.producto.obtenerSegunCodigoBarra
            callback({
                respuesta: response.data.producto.validarProducto.respuesta,
                mensajes: response.data.producto.validarProducto.mensajes,
            });
        });
    }
    ValidarProductoSeguimiento(inputParams, callback) {
        this.gqlclient.query({
            query: gql `
          query ($empresa_rut: Decimal, $codigo: Decimal) {
            producto {
              validarProductoSeguimiento(entidad: { empresa_rut: $empresa_rut, codigo: $codigo }) {
                mensajes {
                  codigo
                  texto
                  tipo
                }
                respuesta {
                  seguimiento
                }
              }
            }
          }
        `,
            variables: inputParams,
            fetchPolicy: 'no-cache',
        }, function (response) {
            // const { mensajes, respuesta } = response.data.producto.obtenerSegunCodigoBarra
            callback({
                respuesta: response.data.producto.validarProductoSeguimiento.respuesta,
                mensajes: response.data.producto.validarProductoSeguimiento.mensajes,
            });
        });
    }
    busquedaXSkuAndCodigoBarra(inputParams, callback) {
        inputParams.descripcion = '';
        inputParams.familia = [];
        this.gqlclient.query({
            query: gql `
          query ($empresa_rut: Decimal, $sku: String, $codigo_barras: String) {
            producto {
              obtenerSegunId(entidad: { empresa_rut: $empresa_rut, sku: $sku, codigo_barras: $codigo_barras }) {
                mensajes {
                  codigo
                  texto
                  tipo
                }
                respuesta {
                  sku
                  codigo_barras
                  descripcion
                }
              }

              obtenerSegunCodigoBarra(entidad: { empresa_rut: $empresa_rut, sku: $sku, codigo_barras: $codigo_barras }) {
                mensajes {
                  codigo
                  texto
                  tipo
                }
                respuesta {
                  sku
                  codigo_barras
                  descripcion
                }
              }
            }
          }
        `,
            variables: inputParams,
            fetchPolicy: 'no-cache',
        }, function (response) {
            let mensajes = [];
            mensajes = mensajes.concat(response.data.producto.obtenerSegunId.mensajes);
            mensajes = mensajes.concat(response.data.producto.obtenerSegunCodigoBarra.mensajes);
            if (response.data.producto.obtenerSegunId.respuesta)
                mensajes = mensajes.concat({
                    texto: 'SKU ya existe',
                    tipo: 'ERROR',
                });
            if (response.data.producto.obtenerSegunCodigoBarra.respuesta)
                mensajes = mensajes.concat({
                    texto: 'Código de barras ya existe',
                    tipo: 'ERROR',
                });
            if (mensajes.length > 0) {
                callback({
                    respuesta: null,
                    mensajes,
                });
                return;
            }
            callback({
                respuesta: response.data.producto.obtenerSegunId.respuesta || response.data.producto.obtenerSegunCodigoBarra.respuesta,
                mensajes,
            });
        });
    }
    GetPrecioUnitario(inputParams, callback) {
        this.gqlclient.query({
            query: gql `
          query ($empresa_rut: Decimal, $producto_codigo: Decimal, $formato_codigo: String, $lista_precio_codigo: Decimal, $tipo_producto_codigo: Decimal) {
            producto {
              obtenerPrecioUnitarioProductoxCombo(
                filtro: { exacto: { empresa_rut: $empresa_rut, producto_codigo: $producto_codigo, formato_codigo: $formato_codigo } }
                lista_precio_codigo: $lista_precio_codigo
                tipo_producto_codigo: $tipo_producto_codigo
              ) {
                respuesta {
                  precio_unitario
                }
              }
            }
          }
        `,
            variables: inputParams,
            fetchPolicy: 'no-cache',
        }, function (response) {
            const { respuesta } = response.data.producto.obtenerPrecioUnitarioProductoxCombo;
            if (!respuesta) {
                callback(null);
                return;
            }
            callback(respuesta);
        });
    }
    agregarProducto(inputParams, callback) {
        this.gqlclient.mutate({
            mutation: gql `
          mutation ($entidad: productoInputType) {
            producto {
              agregarProducto(entidad: $entidad) {
                mensajes {
                  tipo
                  texto
                  codigo
                  contexto
                }
                respuesta {
                  codigo
                  empresa_rut
                  sku
                  codigo_barras
                  descripcion
                  descripcion_ext
                  es_exento
                  afecto_reglas_comerciales
                  no_aplica_descuento
                  fecha_registro
                  favorito
                  activo
                  tipo_producto_codigo
                  unidad_medida_codigo
                  rubro_codigo
                  familia_codigo
                  unidad_negocio_codigo
                  productoFormato {
                    empresa_rut
                    producto_codigo
                    formato_codigo
                    peso_neto
                    volumen
                    fecha_registro
                    cantidad
                    activo
                    formato_codigo_top
                  }
                  productoImpuesto {
                    empresa_rut
                    producto_codigo
                    impuesto_codigo
                    fecha_registro
                  }
                }
              }
            }
          }
        `,
            variables: inputParams,
            fetchPolicy: 'no-cache',
        }, function (response) {
            // const { respuesta } = response.data.producto.agregarProducto
            callback({
                respuesta: response.data.producto.agregarProducto.respuesta,
                mensajes: response.data.producto.agregarProducto.mensajes,
            });
        });
    }
    editarProducto(inputParams, callback) {
        this.gqlclient.mutate({
            mutation: gql `
          mutation ($entidad: productoInputType) {
            producto {
              editarProducto(entidad: $entidad) {
                mensajes {
                  tipo
                  texto
                  codigo
                  contexto
                }
                respuesta {
                  codigo
                  empresa_rut
                  sku
                  codigo_barras
                  descripcion
                  descripcion_ext
                  es_exento
                  afecto_reglas_comerciales
                  no_aplica_descuento
                  fecha_registro
                  favorito
                  activo
                  tipo_producto_codigo
                  unidad_medida_codigo
                  rubro_codigo
                  familia_codigo
                  unidad_negocio_codigo
                  productoFormato {
                    empresa_rut
                    producto_codigo
                    formato_codigo
                    peso_neto
                    volumen
                    fecha_registro
                    cantidad
                    activo
                    formato_codigo_top
                  }
                  productoImpuesto {
                    empresa_rut
                    producto_codigo
                    impuesto_codigo
                    fecha_registro
                  }
                }
              }
            }
          }
        `,
            variables: inputParams,
            fetchPolicy: 'no-cache',
        }, function (response) {
            // const { respuesta } = response.data.producto.editarProducto
            callback({
                respuesta: response.data.producto.editarProducto.respuesta,
                mensajes: response.data.producto.editarProducto.mensajes,
            });
        });
    }
    cambiarEstado(inputParams, callback) {
        this.gqlclient.query({
            query: gql `
          mutation ($entidad: productoInputType) {
            producto {
              cambiarEstado(entidad: $entidad) {
                mensajes {
                  codigo
                  contexto
                  texto
                  tipo
                }
                respuesta {
                  codigo
                  empresa_rut
                  activo
                }
              }
            }
          }
        `,
            variables: inputParams,
            fetchPolicy: 'no-cache',
        }, function (response) {
            callback({
                respuesta: response.data.producto.cambiarEstado.respuesta ? response.data.producto.cambiarEstado.respuesta : null,
                mensajes: response.data.producto.cambiarEstado.mensajes,
            });
        });
    }
    obtenerReporteVentaProductoGeneralResumido(inputParams, callback) {
        this.gqlclient.query({
            query: gql `
          query ($entidad: productoInputType, $paginaActual: Int, $cantidadRegistrosPorPagina: Int) {
            producto {
              obtenerReporteVentaProductoGeneralResumido(entidad: $entidad, paginaActual: $paginaActual, cantidadRegistrosPorPagina: $cantidadRegistrosPorPagina) {
                mensajes {
                  codigo
                  contexto
                  texto
                }
                respuesta {
                  paginaActual
                  cantidadRegistrosPorPagina
                  totalPaginas
                  totalRegistros
                  registros {
                    empresa_rut
                    sucursal_codigo
                    codigo
                    sku
                    formato_codigo
                    formato_nombre
                    descripcion
                    rubro_nombre
                    familia_nombre
                    cantidad
                    monto_neto
                    descuento
                    neto_total
                    listaStockxUnidades {
                      formato_codigo
                      cantidad
                      producto_codigo
                      formato_codigo_top
                      formato_secundario
                      empresa_rut
                      nombre_formato
                      cantidad_formato
                    }
                    listaUnidadesxDocumento {
                      rut_emisor
                      folio
                      tipo_dte_codigo
                      dia_emision
                      producto_codigo
                      formato_codigo
                      sku
                      cantidad
                      precio_neto
                      precio_unitario
                      monto_total_neto
                      monto_total
                      monto
                    }
                  }
                }
              }
            }
          }
        `,
            variables: inputParams,
            fetchPolicy: 'no-cache',
        }, function (response) {
            const { mensajes, respuesta } = response.data.producto.obtenerReporteVentaProductoGeneralResumido;
            callback({ mensajes, respuesta });
        });
    }
    obtenerReporteVentaProductoGeneralResumidoExcel(inputParams, callback) {
        this.gqlclient.query({
            query: gql `
          query ($entidad: productoInputType, $paginaActual: Int, $cantidadRegistrosPorPagina: Int) {
            producto {
              obtenerReporteVentaProductoGeneralResumido(entidad: $entidad, paginaActual: $paginaActual, cantidadRegistrosPorPagina: $cantidadRegistrosPorPagina) {
                mensajes {
                  codigo
                  contexto
                  texto
                }
                respuesta {
                  paginaActual
                  cantidadRegistrosPorPagina
                  totalPaginas
                  totalRegistros
                  registros {
                    rutaArchivo
                  }
                }
              }
            }
          }
        `,
            variables: inputParams,
            fetchPolicy: 'no-cache',
        }, function (response) {
            const { mensajes, respuesta } = response.data.producto.obtenerReporteVentaProductoGeneralResumido;
            callback({ mensajes, respuesta });
        });
    }
    obtenerReporteVentaProductoGeneralDetallado(inputParams, callback) {
        this.gqlclient.query({
            query: gql `
          query ($entidad: productoInputType, $paginaActual: Int, $cantidadRegistrosPorPagina: Int) {
            producto {
              obtenerReporteVentaProductoGeneralDetallado(entidad: $entidad, paginaActual: $paginaActual, cantidadRegistrosPorPagina: $cantidadRegistrosPorPagina) {
                mensajes {
                  codigo
                  contexto
                  texto
                }
                respuesta {
                  paginaActual
                  cantidadRegistrosPorPagina
                  totalPaginas
                  totalRegistros
                  registros {
                    empresa_rut
                    sucursal_codigo
                    codigo
                    sku
                    descripcion
                    formato_codigo
                    formato_nombre
                    cantidad
                    monto_neto
                    descuento
                    neto_total
                    rubro_nombre
                    familia_nombre
                    vendedor_nombre
                    listaStockxUnidades {
                      formato_codigo
                      cantidad
                      producto_codigo
                      formato_codigo_top
                      formato_secundario
                      empresa_rut
                      nombre_formato
                      cantidad_formato
                    }
                    listaUnidadesxDocumento {
                      rut_emisor
                      folio
                      tipo_dte_codigo
                      dia_emision
                      producto_codigo
                      formato_codigo
                      sku
                      cantidad
                      precio_neto
                      precio_unitario
                      monto_total_neto
                      monto_total
                      monto
                      vendedor_codigo
                    }
                  }
                }
              }
            }
          }
        `,
            variables: inputParams,
            fetchPolicy: 'no-cache',
        }, function (response) {
            const { mensajes, respuesta } = response.data.producto.obtenerReporteVentaProductoGeneralDetallado;
            callback({ mensajes, respuesta });
        });
    }
    obtenerReporteVentaProductoGeneralDetalladoExcel(inputParams, callback) {
        this.gqlclient.query({
            query: gql `
          query ($entidad: productoInputType, $paginaActual: Int, $cantidadRegistrosPorPagina: Int) {
            producto {
              obtenerReporteVentaProductoGeneralDetallado(entidad: $entidad, paginaActual: $paginaActual, cantidadRegistrosPorPagina: $cantidadRegistrosPorPagina) {
                mensajes {
                  codigo
                  contexto
                  texto
                }
                respuesta {
                  paginaActual
                  cantidadRegistrosPorPagina
                  totalPaginas
                  totalRegistros
                  registros {
                    rutaArchivo
                  }
                }
              }
            }
          }
        `,
            variables: inputParams,
            fetchPolicy: 'no-cache',
        }, function (response) {
            const { mensajes, respuesta } = response.data.producto.obtenerReporteVentaProductoGeneralDetallado;
            callback({ mensajes, respuesta });
        });
    }
    obtenerReporteVentaProductoAnualizados(inputParams, callback) {
        this.gqlclient.query({
            query: gql `
          query ($entidad: productoInputType, $paginaActual: Int, $cantidadRegistrosPorPagina: Int) {
            producto {
              obtenerReporteVentaProductoAnualizados(entidad: $entidad, paginaActual: $paginaActual, cantidadRegistrosPorPagina: $cantidadRegistrosPorPagina) {
                mensajes {
                  codigo
                  contexto
                  texto
                  tipo
                }
                respuesta {
                  paginaActual
                  cantidadRegistrosPorPagina
                  totalPaginas
                  totalRegistros
                  registros {
                    empresa_rut
                    sucursal_codigo
                    codigo
                    sku
                    descripcion
                    formato_codigo
                    formato_nombre
                    rubro_nombre
                    familia_nombre
                    enero
                    febrero
                    marzo
                    abrir
                    mayo
                    junio
                    julio
                    agosto
                    septiembre
                    octubre
                    noviembre
                    diciembre
                    acumulado
                  }
                }
              }
            }
          }
        `,
            variables: inputParams,
            fetchPolicy: 'no-cache',
        }, function (response) {
            const { mensajes, respuesta } = response.data.producto.obtenerReporteVentaProductoAnualizados;
            callback({ mensajes, respuesta });
        });
    }
    obtenerReporteVentaProductoAnualizadosExcel(inputParams, callback) {
        this.gqlclient.query({
            query: gql `
          query ($entidad: productoInputType, $paginaActual: Int, $cantidadRegistrosPorPagina: Int) {
            producto {
              obtenerReporteVentaProductoAnualizados(entidad: $entidad, paginaActual: $paginaActual, cantidadRegistrosPorPagina: $cantidadRegistrosPorPagina) {
                mensajes {
                  codigo
                  contexto
                  texto
                  tipo
                }
                respuesta {
                  paginaActual
                  cantidadRegistrosPorPagina
                  totalPaginas
                  totalRegistros
                  registros {
                    rutaArchivo
                  }
                }
              }
            }
          }
        `,
            variables: inputParams,
            fetchPolicy: 'no-cache',
        }, function (response) {
            const { mensajes, respuesta } = response.data.producto.obtenerReporteVentaProductoAnualizados;
            callback({ mensajes, respuesta });
        });
    }
    obtenerSegunFiltroProductosFacturables(inputParams, callback) {
        this.gqlclient.query({
            query: gql `
          query (
            $empresa_rut: Decimal
            $sucursal_codigo: Decimal
            $sku: String
            $descripcion: String
            $tipobusquedad_afecto_exento: Int
            $familia: [Decimal]
            $rubro: [Decimal]
            $paginaActual: Int
            $unidad_negocio_codigo: Decimal
            $cantidadRegistrosPorPagina: Int
          ) {
            producto {
              obtenerSegunFiltroProductosFacturables(
                filtro: {
                  exacto: {
                    empresa_rut: $empresa_rut
                    sucursal_codigo: $sucursal_codigo
                    sku: $sku
                    descripcion: $descripcion
                    activo: true
                    tipobusquedad_afecto_exento: $tipobusquedad_afecto_exento
                    unidad_negocio_codigo: $unidad_negocio_codigo
                  }
                }
                familia: $familia
                rubro: $rubro
                paginaActual: $paginaActual
                cantidadRegistrosPorPagina: $cantidadRegistrosPorPagina
              ) {
                mensajes {
                  codigo
                  contexto
                  texto
                  tipo
                }
                respuesta {
                  paginaActual
                  cantidadRegistrosPorPagina
                  totalPaginas
                  totalRegistros
                  registros {
                    codigo
                    empresa_rut
                    sku
                    descripcion
                    descripcion_ext
                    es_exento
                    codigo_barras
                    fecha_registro
                    activo
                    favorito
                    familia_codigo
                    tipo_producto_codigo
                    unidad_medida_codigo
                    afecto_reglas_comerciales
                    no_aplica_descuento
                    fecha_caducidad_combo
                    fecha_inicio_combo
                    rubro_codigo
                    unidad_negocio_codigo
                    formato_codigo
                    formato_nombre
                    cantidad
                  }
                }
              }
            }
          }
        `,
            variables: inputParams,
            fetchPolicy: 'no-cache',
        }, function (response) {
            const { mensajes, respuesta } = response.data.producto.obtenerSegunFiltroProductosFacturables;
            callback({ mensajes, respuesta });
        });
    }
    obtenerSegunFiltroProductosUnidadNegocio(inputParams, callback) {
        this.gqlclient.query({
            query: gql `
          query ($entidad: productoInputType, $paginaActual: Int, $cantidadRegistrosPorPagina: Int) {
            producto {
              obtenerSegunFiltroProductosUnidadNegocio(entidad: $entidad, paginaActual: $paginaActual, cantidadRegistrosPorPagina: $cantidadRegistrosPorPagina) {
                mensajes {
                  codigo
                  contexto
                  tipo
                  texto
                }
                respuesta {
                  paginaActual
                  cantidadRegistrosPorPagina
                  totalPaginas
                  totalRegistros
                  registros {
                    codigo
                    empresa_rut
                    sku
                    descripcion
                    descripcion_ext
                    es_exento
                    codigo_barras
                    fecha_registro
                    activo
                    favorito
                    familia_codigo
                    tipo_producto_codigo
                    unidad_medida_codigo
                    afecto_reglas_comerciales
                    no_aplica_descuento
                    fecha_caducidad_combo
                    fecha_inicio_combo
                    rubro_codigo
                    unidad_negocio_codigo
                    precio_unitario
                  }
                }
              }
            }
          }
        `,
            variables: inputParams,
            fetchPolicy: 'no-cache',
        }, function (response) {
            const { mensajes, respuesta } = response.data.producto.obtenerSegunFiltroProductosUnidadNegocio;
            callback({ mensajes, respuesta });
        });
    }
    obtenerSegunFiltroProductosConSaldos(inputParams, callback) {
        this.gqlclient.query({
            query: gql `
          query (
            $empresa_rut: Decimal
            $sucursal_codigo: Decimal
            $sku: String
            $descripcion: String
            $tipobusqueda_estado: Int
            $tipobusquedad_afecto_exento: Int
            $bodega_codigo: Decimal
            $familia: [Decimal]
            $rubro: [Decimal]
            $paginaActual: Int
            $cantidadRegistrosPorPagina: Int
          ) {
            producto {
              obtenerSegunFiltroProductosConSaldos(
                filtro: {
                  exacto: {
                    empresa_rut: $empresa_rut
                    sucursal_codigo: $sucursal_codigo
                    sku: $sku
                    descripcion: $descripcion
                    tipobusqueda_estado: $tipobusqueda_estado
                    tipobusquedad_afecto_exento: $tipobusquedad_afecto_exento
                    bodega_codigo: $bodega_codigo
                  }
                }
                familia: $familia
                rubro: $rubro
                paginaActual: $paginaActual
                cantidadRegistrosPorPagina: $cantidadRegistrosPorPagina
              ) {
                mensajes {
                  tipo
                  texto
                  codigo
                  contexto
                }
                respuesta {
                  paginaActual
                  cantidadRegistrosPorPagina
                  totalPaginas
                  totalRegistros
                  registros {
                    codigo
                    empresa_rut
                    sku
                    descripcion
                    descripcion_ext
                    es_exento
                    codigo_barras
                    fecha_registro
                    activo
                    favorito
                    familia_codigo
                    tipo_producto_codigo
                    unidad_medida_codigo
                    afecto_reglas_comerciales
                    no_aplica_descuento
                    fecha_caducidad_combo
                    fecha_inicio_combo
                    rubro_codigo
                    unidad_negocio_codigo
                    precio_unitario
                    formato_codigo
                    formato_nombre
                    cantidad
                  }
                }
              }
            }
          }
        `,
            variables: inputParams,
            fetchPolicy: 'no-cache',
        }, function (response) {
            const { mensajes, respuesta } = response.data.producto.obtenerSegunFiltroProductosConSaldos;
            callback({ mensajes, respuesta });
        });
    }
}
ProductoService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function ProductoService_Factory() { return new ProductoService(i0.ɵɵinject(i1.GraphQLClient), i0.ɵɵinject(i2.Apollo)); }, token: ProductoService, providedIn: "root" });
